export const headers = {
  email: {
    name: "Email",
    width: 1.7,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  display_name: {
    name: "Display Name",
    width: 1.7,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  zone_info: {
    name: "Zone",
    width: 1,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  role: {
    name: "Role",
    width: 1,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  team: {
    name: "Team",
    width: 1,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  last_login: {
    name: "Last Login",
    width: 1,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const MediumDeviceHeaders = {
  email: {
    name: "Email",
    width: 1.7,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  display_name: {
    name: "Display Name",
    width: 1,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  "": { name: "", width: 0.3, textAlign: "" },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const SmallDeviceHeaders = {
  email: {
    name: "Email",
    width: 1.0,
    textAlign: "left",
    isSort: true,
    sortDirection: "",
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};
